import {FC} from 'react'
import {HeartIcon} from '../SvgIcon'
import {footerLinks} from 'definitions/constant'
import {useTranslation} from 'react-i18next'

export const Footer: FC = () => {
  const {t} = useTranslation(['footer'])
  const currentYear = new Date().getFullYear()

  return (
    <div
      data-cy="login-footer-container"
      className="w-full flex justify-between items-baseline px-10 absolute bottom-8"
    >
      <div className="w-5/12 flex justify-start items-baseline">
        <p className="text-10px abc-regular font-bold">
          {t('FOOTER_DOPE_HEADING')}
        </p>
        <p className="abc-exl text-gray-1000 font-light text-10px ml-6">
          {t('FOOTER_DOPE_INC', {year: currentYear})}
        </p>
      </div>
      <div className="abc-exl w-5/12 flex justify-center items-baseline text-gray-1000 text-9px">
        {t('FOOTER_MADE_WITH')}
        <HeartIcon
          strokeColor="text-gray-400"
          strokeWidth={0.4}
          classes="-mt-1"
          width={18}
          height={8}
          fillColor="#FFFFFF"
        />
        {t('FOOTER_MADE_IN')}
      </div>
      <div className="w-5/12 flex justify-end items-baseline">
        <p className="abc-exl text-gray-1000 font-light text-10px ml-6">
          {t('FOOTER_PATENT_HEADING')}
        </p>
        <a href={footerLinks.patentLink} target="_blank">
          <p className="text-10px ml-1 abc-regular text-gray-10 font-normal underline">
            {t('FOOTER_PATENT_VALUE')}
          </p>
        </a>
      </div>
    </div>
  )
}
